export default __webpack_public_path__ + "app/images/theme-images/shared/ic-60-chat.svg";